import React from 'react';
import { connect } from 'redux-zero/react';
import cn from 'classnames';
import { injectIntl } from 'react-intl';

import CommunityPageService from './community.service.js';
import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './community.scss';

const SectorCard = ({
	title, places, image, index,
}) => (
	<section className=" col-lg-12 col-md-12 col-sm-12 col-xs-12">
		<div className="sector-card row">
			{index % 2 !== 0 && (
				<div className={cn('col col-lg-6 col-md-6 col-sm-12 col-xs-12 first-lg first-md first-sm first-xs image', { 'shape center-xs': index === 3 })}>
					{image && (
						<img
							alt=""
							src={`${process.env.REACT_APP_API_ENDPOINT}${image.path}`}
						/>
					)}
				</div>
			)}

			<div className="col col-lg-6 col-md-6 col-sm-12 col-xs-12 last-md last-xs specs">
				{title && <div className="title">{title}</div>}
				{places && (
					<div
						className=" places"
						dangerouslySetInnerHTML={{ __html: places }}
					/>
				)}
			</div>
			{index % 2 === 0 && (
				<div className="col col-lg-6 col-md-6 col-sm-12 col-xs-12 last-lg first-md first-sm first-xs image">
					{image && (
						<img
							alt=""
							src={`${process.env.REACT_APP_API_ENDPOINT}${image.path}`}
						/>
					)}
				</div>
			)}
		</div>
	</section>
);

class CommunityPage extends React.Component {
	static prefetchData = async language => CommunityPageService.getPageData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		ScrollToTop();
		if (!this.props.communityPageData) {
			this.fetchData();
		} else {
			this.props.setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		ScrollToTop();
		if (prevProps.language.value !== this.props.language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		this.props.setLoading(true);
		CommunityPage.prefetchData(this.props.language.value)
			.then((res) => {
				this.props.setCommunityPageData(res);
				this.props.setLoading(false);
			})
			.catch((error) => {
				this.setState({
					hasError: true,
				});
				this.props.setLoading(false);
				console.log(error);
			});
	}

	render() {
		const { communityPageData, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;

		if (hasError || !communityPageData) {
			return <NotImplemented title="Community" />;
		}

		const {
			title,
			description,
			title2,
			title3,
			mapImage,
			sectors,
		} = communityPageData;

		return (
			<div className="community-page">
				<Seo
					title={formatMessage({ id: 'navigation.about.community' })}
					description={description || formatMessage({ id: 'navigation.about.ourVision' })}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "AboutPage",
											"name": "${title}",
											"description": "${description}",
											"image": "${mapImage && `${process.env.REACT_APP_API_ENDPOINT}${mapImage.path}`}"
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.about.community' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/about/community"
												}
											]
										}
									]
								}`}
				/>
				<div className="container container-fluid">
					<div className="section row intro">
						<div className="title col-lg-4 col-md-4 col-sm-12 col-xs-12">
							{title}
						</div>
						<div className="description col-lg-8 col-md-8 col-sm-12 col-xs-12">
							{description}
						</div>
					</div>
					<div className="section world-map">
						<div className="section subtitle">
							{title2}
							{' '}
						</div>
						<div className="world-map-image">
							{mapImage && (
								<img
									alt=""
									src={`${process.env.REACT_APP_API_ENDPOINT}${mapImage.path}`}
								/>
							)}
						</div>
					</div>
					<div className="section subtitle">
						{title3}
						{' '}
					</div>
					<div className="sectors">
						<div className=" row">
							{sectors
								&& sectors.map((entry, index) => (
									<SectorCard
										key={index}
										title={entry.value.title}
										places={entry.value.Places}
										image={entry.value.image}
										index={index}
									/>
								))}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapToProps = ({ language, communityPageData, addresses, phones, generalData }) => ({
	language,
	communityPageData,
	addresses,
	phones,
	generalData,
});

export default injectIntl(
	connect(
		mapToProps,
		actions,
	)(CommunityPage),
);

export { CommunityPage };
